export const timezones = Intl.supportedValuesOf('timeZone');

export const prettifyTimezoneName = (input: string): string =>
  input.replace(/\//g, ' - ').replace(/_/g, ' ');

export const timezoneOptions = [...timezones, 'Etc/UTC'].map((tz) => ({
  name: prettifyTimezoneName(tz),
  value: tz,
}));
